'use strict';

import {upperFirst as _uf} from 'lodash';

const Controller = require('../../shared/controller');
const FiltersController = require('../../components/filters-hash');
const BasicMetrics = require('./basic-metrics');
const FilteredMonitor = require('./metrics-by-filter');
import CustomerInfo from './customer-info';
const config = require('../../shared/config');

const DASHBOARD_TEMPLATE = require('../../templates/dashboard.html');
class Dashboard extends Controller {
	constructor(options) {
		super({template: DASHBOARD_TEMPLATE}, options);
		this.filters = new FiltersController();
		this.metrics = new BasicMetrics({title: 'Basic metrics', method: 'dashboard/metrics'});
		this.monitor = new FilteredMonitor({method: 'dashboard/metrics-by-filter'});
		this.customerInfo = new CustomerInfo({method: 'dashboard/customer-info'});
	}

	reloadMetrics() {
		let params = this.filters.getQueryParams();
		return Promise.all([
			this.metrics.reload({params}),
			this.monitor.update({params})
		]);
	}

	getRenderOptions(options) {
		let configuredFilters = config.get('Filters');
		let filters = [];
		for (let f of configuredFilters) {
			if (Array.isArray(f)) {
				filters.push(f);
			} else {
				filters.push([_uf(f), f]);
			}
		}
		return Object.assign({filters}, super.getRenderOptions(options));
	}

	render(options) {
		let self = this;
		return super.render(options)
			.then(function () {
				let c = self.container;
				let filtersContainer = c.querySelector('#filters');
				let metricsContainer = c.querySelector('#dashboard-metrics');
				let monitorContainer = c.querySelector('#grouped-metrics');
				let customerInfoContainer = c.querySelector('#customer-info');

				return self.filters
					.load({container: filtersContainer, template: null})
					.then(function () {
						let params = self.filters.getQueryParams();
						return Promise.all([
							self.metrics.load({container: metricsContainer, params}),
							self.monitor.render({container: monitorContainer, params}),
							self.customerInfo.load({container: customerInfoContainer, params})
						])
					})
					.then(function () {
						let $container = self.$container;
						let refreshButton = $container.find('.cm-refresh');
						refreshButton.popover({
							placement: 'bottom', trigger: 'manual',
							content: 'The filters have changed. Press refresh to update the dashboard.'
						});
						let reloadMetrics = function () {
							refreshButton.popover('hide');
							self.reloadMetrics();
							return false;
						};
						$container.find('.cm-reset').on('click', function () {
							self.filters.reset();
							reloadMetrics();
							return false;
						});
						refreshButton.on('click', function () {
							reloadMetrics();
							return false;
						});
						self.filters.addListener('cm:update', function () {
							refreshButton.popover('show');
						});
					});
			});
	}
}

export default Dashboard;
